import SectionHeading from "./SectionHeading";
import { galleryItems } from "@/mocks/home";

type LatestGalleryProps = {
  active: string;
};

const typeLabel: Record<string, string> = {
  person: "人物合集",
  event: "事件归档",
  pack: "打包专区",
};

export default function LatestGallery({ active }: LatestGalleryProps) {
  const items = active === "all" ? galleryItems : galleryItems.filter((item) => item.type === active);

  return (
    <section id="latest" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          index="02"
          eyebrow="Latest Archive"
          title="最新收录 · 大图卡片流"
          desc="按更新时间倒序排列，标题优先标注事件与人物，配图克制只作线索。点击任意卡片可进入对应图集，从第一张翻到最后一张。"
        />

        {items.length === 0 ? (
          <div className="mt-10 flex flex-col items-center gap-2 rounded-lg border border-dashed border-background-300 bg-background-50 py-16 text-center">
            <span className="flex h-12 w-12 items-center justify-center rounded-md bg-background-200 text-foreground-600">
              <i className="ri-inbox-line text-2xl"></i>
            </span>
            <p className="mt-2 text-sm font-medium text-foreground-800">当前筛选下暂无收录内容</p>
            <p className="text-xs text-foreground-500">可切换到「全部收录」查看完整图集目录。</p>
          </div>
        ) : (
          <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {items.map((item) => (
              <article
                key={item.id}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
              >
                <div className="relative h-48 w-full overflow-hidden md:h-52">
                  <img
                    src={item.image}
                    alt={`${item.title} 黑料照片合集`}
                    title={`${item.person}${item.event} 黑料照片原图`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                  <span className="absolute left-3 top-3 rounded-md bg-primary-500 px-2.5 py-1 text-[11px] font-semibold text-background-50">
                    {item.badge}
                  </span>
                  <span className="absolute right-3 top-3 rounded-md border border-background-50/30 bg-foreground-950/60 px-2.5 py-1 text-[11px] font-medium text-background-100 backdrop-blur">
                    {typeLabel[item.type]}
                  </span>
                </div>

                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950">{item.title}</h3>
                  <p className="mt-3 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-user-line text-sm"></i>
                      {item.person}
                    </span>
                    <span className="h-3 w-px bg-background-300"></span>
                    <span className="flex items-center gap-1">
                      <i className="ri-price-tag-3-line text-sm"></i>
                      {item.event}
                    </span>
                  </p>

                  <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-600">
                    <span className="flex items-center gap-1 font-semibold text-accent-700">
                      <i className="ri-stack-line text-sm"></i>
                      {item.count} 张
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line text-sm"></i>
                      {item.updated}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line text-sm"></i>
                      {item.views}
                    </span>
                  </div>

                  <a
                    href="#packages"
                    className="mt-4 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors group-hover:border-primary-300 group-hover:text-primary-700"
                  >
                    翻看完整图集
                    <i className="ri-arrow-right-up-line text-base"></i>
                  </a>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}